import React, { useContext, useState } from 'react';
// import { FaArrowRightLong } from "react-icons/fa6";
import { FormContext } from './Provider';
import { useNavigate } from 'react-router-dom';
// import Progress from './Progress';

export default function AdmissionForm({ step, setStep }) {
    console.log("step:", step, "setStep:", setStep); // Debug line
    const navigate = useNavigate()
    const { formData, setFormData } = useContext(FormContext);
    const [errors, setErrors] = useState({
        fullName: '',
        dob: '',
        gender: '',
        parentName: '',
        address: '',
        contactno: '',
        alternateNumber: '',
        email: '',
        pincode: '',
        emergency: '',
        proofOfIdentity: '',
        image: '',
        profilePic: ''
    });


    // const [previewURL, setPreviewURL] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Update file in state
            const preview = URL.createObjectURL(file);

            setFormData((prev) => ({
                ...prev,
                image: file,
                imagePreview: preview,
            }));

            // Create object URL for preview


            setErrors((prev) => ({
                ...prev,
                image: '',
            }));
        }
    };

// Profile Picture
    const handleProfileFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Update file in state
            const preview = URL.createObjectURL(file);

            setFormData((prev) => ({
                ...prev,
                profilePic: file,
                profilePreview: preview,
            }));

            // Create object URL for preview


            setErrors((prev) => ({
                ...prev,
                profilePic: '',
            }));
        }
    };
    // Revoke object URL on cleanup
    // useEffect(() => {
    //     return () => {
    //         if (previewURL) {
    //             URL.revokeObjectURL(previewURL);
    //         }
    //     };
    // }, [previewURL]);

    const handleChange = (e, field) => {
        const value = e.target.value;

        setFormData((prevData) => ({
            ...prevData,
            [field]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [field]: '',
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = {};

        formData.fullName = formData.fullName
            .trim()
            .split(/\s+/)
            .map(word =>
                word.length === 1
                    ? word.toUpperCase()
                    : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(' ');

        if (!formData.fullName.trim()) {
            newErrors.fullName = 'Please enter your full name.';
        } else if (!/^(?:[A-Z]+\.?|[A-Z][a-z]+)([. ](?:[A-Z]+\.?|[A-Z][a-z]+))*$/.test(formData.fullName)) {
            newErrors.fullName = 'Please enter a valid name. Use capital letters at the beginning .';
        }


        if (!formData.dob) {
            newErrors.dob = 'Please enter your date of birth.';
        } else if (!/^\d{4}-\d{2}-\d{2}$/.test(formData.dob)) {
            newErrors.dob = 'Date must be in YYYY-MM-DD format.';
        }

        if (!formData.parentName.trim()) {
            newErrors.parentName = `Please enter your Patent's / Guardian name.`;
        }

        if (!formData.gender) {
            newErrors.gender = 'Please select your gender.';
        }

        if (!formData.address.trim()) {
            newErrors.address = 'Please enter your address.';
        }

        if (!formData.contactno.trim()) {
            newErrors.contactno = 'Please enter your contact number.';
        } else if (!/^\d{10}$/.test(formData.contactno)) {
            newErrors.contactno = 'Contact number must be 10 digits.';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Please enter your email.';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Invalid email format.';
        }

        if (!formData.pincode.trim()) {
            newErrors.pincode = 'Please enter your pincode.';
        } else if (!/^\d{6}$/.test(formData.pincode)) {
            newErrors.pincode = 'Pincode must be 6 digits.';
        }

        if (!formData.emergency.trim()) {
            newErrors.emergency = 'Please enter your contact number.';
        } else if (!/^\d{10}$/.test(formData.emergency)) {
            newErrors.emergency = 'Contact number must be 10 digits.';
        }

        if (!formData.proofOfIdentity) {
            newErrors.proofOfIdentity = 'Please select your proof of identity.';
        }

        if (!formData.image) {
            newErrors.image = 'Please upload an image.';
        } else if (!['image/jpeg', 'image/png', 'image/gif'].includes(formData.image.type)) {
            newErrors.image = 'Only JPG, PNG, and GIF files are allowed.';
        }

        if (!formData.profilePic) {
            newErrors.profilePic = 'Please upload an image.';
        } else if (!['image/jpeg', 'image/png', 'image/jpg'].includes(formData.profilePic.type)) {
            newErrors.profilePic = 'Only JPG, PNG, and GIF files are allowed.';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {

            setErrors({});
            navigate('/admission-form');
            setStep(step + 1)
            // console.log('Form Submitted:', {
            //     fullName,
            //     dob,
            //     gender,
            //     address,
            //     contactno,
            //     email,
            //     pincode,
            //     proofOfIdentity,
            //     image,
            // });
        }


    };

    return (
        <section>

            <div className="w-full pt-2">
                <section className="bg-white rounded-lg shadow-md p-4 sm:p-6">
                    <div className="bg-gray-100 px-2 sm:px-4 py-4 w-full">
                        <div className="flex justify-center items-center w-full">
                            <div className="w-full max-w-lg md:max-w-4xl mx-auto px-0 sm:px-2">
                                <div className="card shadow-lg  rounded-xl">
                                    <div className="card-body p-3 sm:p-5">
                                        <h3 className="font-bold text-lg text-primary-800">
                                            Personal Details
                                        </h3>
                                        <h4 className="pt-2 text-gray-700">
                                            Please Provide Your Personal Information
                                        </h4>
                                        <form onSubmit={handleSubmit} >
                                            {/* Full Name Field */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-8">
                                                {/* Full Name Field */}
                                                <div className="mb-4 w-full">
                                                    <div className="relative">
                                                        <input
                                                            type="text"
                                                            id="fullname"
                                                            value={formData.fullName}
                                                            onChange={(e) => handleChange(e, 'fullName')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" "
                                                            required
                                                        />
                                                        <label
                                                            htmlFor="fullname"
                                                            className="absolute text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 start-1 font-medium text-base"
                                                        >
                                                            Full Name <span className='text-red-600 text-lg'> *</span>
                                                        </label>
                                                    </div>
                                                    {errors.fullName && (
                                                        <p className="text-sm text-red-500">

                                                            {errors.fullName}
                                                        </p>
                                                    )}
                                                </div>

                                                {/* Date of Birth Field */}
                                                <div className="mb-4 w-full">
                                                    <div className="relative">
                                                        <input
                                                            type="date"
                                                            id="dob"
                                                            value={formData.dob}
                                                            onChange={(e) => handleChange(e, 'dob')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" "
                                                            required
                                                        />
                                                        <label
                                                            htmlFor="dob"
                                                            className="absolute text-base text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[3] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 font-medium"
                                                        >
                                                            Date of Birth <span className='text-red-600 text-lg'> *</span>
                                                        </label>
                                                    </div>
                                                    {errors.dob && (
                                                        <p className="text-sm text-red-500 ">
                                                            {errors.dob}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>


                                            {/* Date of Birth and Gender */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="text"
                                                            id="parentName"
                                                            value={formData.parentName}
                                                            onChange={(e) => handleChange(e, 'parentName')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" "
                                                        />
                                                        <label htmlFor="parentName" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 
                                                        peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1  text-base font-medium"> Parent's / Guardian Name <span className='text-red-600 text-lg'> *</span>
                                                        </label>
                                                    </div>
                                                    {errors.parentName && (
                                                        <p className="text-sm text-red-500">
                                                            {errors.parentName}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className="mb-4 w-full">
                                                    <h6 className="mb-2 pb-1 font-medium">Gender: <span className='text-red-600 text-lg'> *</span></h6>

                                                    <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3">
                                                        {/* Male */}
                                                        <div className="flex items-center">
                                                            <input
                                                                id="male"
                                                                type="radio"
                                                                name="gender"
                                                                value="male"
                                                                onChange={(e) => handleChange(e, 'gender')}
                                                                checked={formData.gender === 'male'}
                                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600"
                                                                required
                                                            />
                                                            <label htmlFor="male" className="ms-2 text-sm font-medium text-gray-900 ">
                                                                Male
                                                            </label>
                                                        </div>

                                                        {/* Female */}
                                                        <div className="flex items-center">
                                                            <input
                                                                id="female"
                                                                type="radio"
                                                                name="gender"
                                                                value="female"
                                                                onChange={(e) => handleChange(e, 'gender')}
                                                                checked={formData.gender === 'female'}
                                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600"
                                                            />
                                                            <label htmlFor="female" className="ms-2 text-sm font-medium text-gray-900 ">
                                                                Female
                                                            </label>
                                                        </div>

                                                        {/* Other */}
                                                        <div className="flex items-center">
                                                            <input
                                                                id="other"
                                                                type="radio"
                                                                name="gender"
                                                                value="other"
                                                                checked={formData.gender === 'other'}
                                                                onChange={(e) => handleChange(e, 'gender')}
                                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600"
                                                            />
                                                            <label htmlFor="other" className="ms-2 text-sm font-medium text-gray-900 ">
                                                                Other
                                                            </label>
                                                        </div>
                                                    </div>

                                                    {errors.gender && (
                                                        <p className="text-sm text-red-500 ">

                                                            {errors.gender}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            {/* Address and Pincode */}
                                            <div className="grid grid-cols">
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <textarea
                                                            type="text"
                                                            id="address"
                                                            value={formData.address}
                                                            onChange={(e) => handleChange(e, 'address')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="address" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 
                                                        peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base">
                                                            Address <span className='text-red-600 text-lg'> *</span></label>
                                                    </div>
                                                    {errors.address && (
                                                        <p className="text-sm text-red-500  ">

                                                            {errors.address}
                                                        </p>
                                                    )}
                                                </div>


                                            </div>

                                            {/* Contact and Alternative Number */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            id="contactNumber"
                                                            value={formData.contactno}
                                                            onChange={(e) => handleChange(e, 'contactno')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="contactNumber" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600
                                                     peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base">
                                                            Contact Number <span className='text-red-600 text-lg'> *</span></label>
                                                    </div>
                                                    {errors.contactno && (
                                                        <p className="text-sm text-red-500  ">

                                                            {errors.contactno}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            id="alternateNumber"
                                                            value={formData.alternateNumber}
                                                            onChange={(e) => handleChange(e, 'alternateNumber')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" "
                                                        />
                                                        <label htmlFor="alternateNumber" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[1] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 
                                                    peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base"> Alternative Contact Number
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {/* Email Field */}
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="email"
                                                            id="emailAddress"
                                                            value={formData.email}
                                                            onChange={(e) => handleChange(e, 'email')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="emailAddress" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 
                                                        peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base">
                                                            Email <span className='text-red-600 text-lg'> *</span>
                                                        </label>
                                                    </div>
                                                    {errors.email && (
                                                        <p className="text-sm text-red-500  ">

                                                            {errors.email}
                                                        </p>
                                                    )}
                                                </div>

                                                {/* Pincode Field */}
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            id="pincode"
                                                            value={formData.pincode}
                                                            onChange={(e) => handleChange(e, 'pincode')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="pincode" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 
                                                        peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base"> Pincode <span className='text-red-600 text-lg'> *</span>
                                                        </label>
                                                    </div>
                                                    {errors.pincode && (
                                                        <p className="text-sm text-red-500 ">

                                                            {errors.pincode}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {/* Emergency Contact Field */}
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <input
                                                            type="number"
                                                            id="emergency"
                                                            value={formData.emergency}
                                                            onChange={(e) => handleChange(e, 'emergency')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                                            placeholder=" " required
                                                        />
                                                        <label htmlFor="emergency" className="absolute  text-gray-500 dark:text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                                                         peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1 font-medium text-base">
                                                            Emergency Contact Number <span className='text-red-600 text-lg'> *</span>
                                                        </label>
                                                    </div>
                                                    {errors.emergency && (
                                                        <p className="text-sm text-red-500 ">
                                                            {errors.emergency}
                                                        </p>
                                                    )}
                                                </div>

                                                {/* Proof of Identity Selection */}
                                                <div className="mb-4">
                                                    <div className="relative">
                                                        <select
                                                            id="proofOfIdentity"
                                                            value={formData.proofOfIdentity}
                                                            onChange={(e) => handleChange(e, 'proofOfIdentity')}
                                                            className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" required
                                                        >
                                                            <option value="" disabled>
                                                                Select Proof of Identity
                                                            </option>
                                                            <option> ID card</option>
                                                            <option value="aadhaar">Aadhaar</option>
                                                            <option value="passport">Passport</option>
                                                            <option value="voterId">Voter ID</option>
                                                            <option value="drivingLicense">Driving License</option>

                                                        </select>
                                                        {/* Dropdown arrow icon */}
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M5.23 7.79a1 1 0 011.41 0L10 11.12l3.36-3.33a1 1 0 111.42 1.41l-4 4a1 1 0 01-1.42 0l-4-4a1 1 0 010-1.41z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                        <label
                                                            htmlFor="proofOfIdentity"
                                                            className="absolute  text-gray-500 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[3] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:scale-75 peer-focus:-translate-y-5 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 font-medium text-base"
                                                        >
                                                            Proof of Identity <span className='text-red-600 text-lg'> *</span>
                                                        </label>
                                                    </div>
                                                    {errors.proofOfIdentity && (
                                                        <p className="text-sm text-red-500 ">
                                                            {errors.proofOfIdentity}
                                                        </p>
                                                    )}
                                                </div>

                                            </div>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <label className='font-medium mb-3'>Upload Proof File: <span className='text-red-600 text-lg'> *</span></label>
                                                    <div className="flex items-center justify-center w-full">
                                                        <label
                                                            htmlFor="dropzone-fileee"
                                                            className={`flex flex-col items-center justify-center w-full h-44 cursor-pointer ${!formData.imagePreview ? 'border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 hover:bg-gray-100 transition duration-200' : ''} `}
                                                        >
                                                            {/* 👇 Conditional Preview or Default SVG Instructions */}
                                                            {formData.imagePreview ? (
                                                                <div className="flex items-center justify-start w-full h-full  ">
                                                                    <img
                                                                        src={formData.imagePreview}
                                                                        alt="Preview"
                                                                        className="h-full object-contain  border-2 border-gray-300 border-dashed rounded-lg"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div className="flex flex-col items-center justify-center pt-5 pb-6 ">
                                                                    <svg
                                                                        className="w-8 h-8 mb-4 text-gray-500"
                                                                        aria-hidden="true"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        fill="none"
                                                                        viewBox="0 0 20 16"
                                                                    >
                                                                        <path
                                                                            stroke="currentColor"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            strokeWidth="2"
                                                                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5
                5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5
                5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                                                        />
                                                                    </svg>
                                                                    <p className="mb-2 text-sm text-gray-500">
                                                                        <span className="font-semibold">Click to upload</span> or drag and drop
                                                                    </p>
                                                                    <p className="text-xs text-gray-500">SVG, PNG, JPG or GIF (MAX. 500x400px)</p>
                                                                </div>
                                                            )}

                                                            <input
                                                                id="dropzone-fileee"
                                                                type="file"
                                                                className="hidden"
                                                                onChange={handleFileChange}
                                                                required
                                                            />
                                                        </label>
                                                    </div>
                                                    {(errors.image) && (
                                                        <p className="text-sm text-red-500 ">{errors.image}</p>
                                                    )}
                                                </div>
                                                
                                                {/* Profile Pic :- */}
                                                <div>
                                                    <label className='font-medium mb-3'>Upload Profile Pic: <span className='text-red-600 text-lg'> *</span></label>
                                                    <div className="flex items-center justify-center w-full">
                                                        <label
                                                            htmlFor="dropzone-file"
                                                            className={`flex flex-col items-center justify-center w-full h-44 cursor-pointer ${!formData.profilePreview ? 'border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 hover:bg-gray-100 transition duration-200' : ''} `}
                                                        >
                                                            {/* 👇 Conditional Preview or Default SVG Instructions */}
                                                            {formData.profilePreview ? (
                                                                <div className="flex items-center justify-start w-full h-full  ">
                                                                    <img
                                                                        src={formData.profilePreview}
                                                                        alt="Preview"
                                                                        className="h-full object-contain  border-2 border-gray-300 border-dashed rounded-lg"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div className="flex flex-col items-center justify-center pt-5 pb-6 ">
                                                                    <svg
                                                                        className="w-8 h-8 mb-4 text-gray-500"
                                                                        aria-hidden="true"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        fill="none"
                                                                        viewBox="0 0 20 16"
                                                                    >
                                                                        <path
                                                                            stroke="currentColor"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            strokeWidth="2"
                                                                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5
                5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5
                5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                                                        />
                                                                    </svg>
                                                                    <p className="mb-2 text-sm text-gray-500">
                                                                        <span className="font-semibold">Click to upload</span> or drag and drop
                                                                    </p>
                                                                    <p className="text-xs text-gray-500">SVG, PNG, JPG or GIF (MAX. 500x400px)</p>
                                                                </div>
                                                            )}

                                                            <input
                                                                id="dropzone-file"
                                                                type="file"
                                                                className="hidden"
                                                                onChange={handleProfileFileChange}
                                                                required
                                                            />
                                                        </label>
                                                    </div>
                                                    {(errors.profilePic) && (
                                                        <p className="text-sm text-red-500 ">{errors.profilePic}</p>
                                                    )}
                                                </div>
                                             
                                            </div>

                                            {/* Submit Button */}
                                            <div className="mt-4 pt-2">
                                                <button
                                                    type="submit"
                                                    onClick={handleSubmit}

                                                    className=" float-end py-2 px-4 rounded-md text-base font-medium text-white bg-primary-800 hover:bg-primary-700 focus:outline-none flex align-items-center gap-2"
                                                >
                                                    Next
                                                    {/* <FaArrowRightLong /> */}
                                                </button>


                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    );
}
